// Snow golem override (MOB-2 golem, ranged — M13.1). PURE (ENG-1).
//
// A constructed golem that pelts the nearest hostile monster with snowballs
// instead of punching it, and melts (takes damage) while standing in water or
// out in the rain — the snow golem's iconic weakness.
import { GOLEM } from '../../config';
import type { MobDef } from '../../registry/schemas';
import type { Entity, MobContext } from '../entity';
import { golemTarget } from '../archetypes/golem';
import { wander } from '../archetypes/shared';
import { fireSnowballAt } from '../projectiles/snowball';

export function snowGolem(e: Entity, def: MobDef, ctx: MobContext): void {
  // Melt in water or rain (a bite of self-damage on a cadence — HP is small).
  const wet = ctx.world.isFluid(Math.floor(e.x), Math.floor(e.y + 0.2), Math.floor(e.z));
  if ((wet || ctx.frame.raining) && e.age % 10 === 0) {
    ctx.sys.damage(e, GOLEM.MELT_DAMAGE, ctx.frame);
    if (e.removed) return;
  }

  const target = golemTarget(e, ctx);
  if (target) {
    e.yaw = Math.atan2(-(target.x - e.x), -(target.z - e.z));
    e.data.fireCd = (e.data.fireCd ?? 0) - 1;
    if (e.data.fireCd <= 0) {
      fireSnowballAt(ctx.sys, e, target.x, target.y + 0.5, target.z);
      e.data.fireCd = GOLEM.SNOWBALL_INTERVAL;
    }
    return; // hold ground and throw
  }
  wander(e, ctx, def);
}
